<div class="error-modal">
    <!-- <svg-icon src="assets/images/portal/order-details-card/order-cancelled.svg"></svg-icon> -->
    <div style="margin-top: 10px;">
      <h3>
        {{ errorTitle }}
      </h3>
    </div>

    <div *ngIf="errors" style="margin-top: 10px;">
      <ul>
        <li *ngFor="let error of errors">
          {{ error.errorMessage }}
        </li>
      </ul>
    </div>
    <div *ngIf="!errors && error" style="margin-top: 10px;">
      <p>
        {{ error.errorMessage }}
      </p>
    </div>
    <button class="btn btn-primary" (click)="okOnClick()">
      Ok
    </button>
  </div>